import { useMsal } from '@azure/msal-react'
import React from 'react'
import { usePermissionByUser } from 'services/autenticacion/usuarios/permissions/get'

export const AppContext = React.createContext({
  rolData: {},
  isLoadingPermissions: false,
  permissionsError: null,
  envConfig: null
})

export function AppProvider({ children }) {
  const { accounts } = useMsal()
  const envConfig = accounts?.[0]?.username
  const hasAccount = accounts?.length > 0
  const shouldFetch = hasAccount && !!envConfig
  const { isLoading, data, isError } = usePermissionByUser(
    shouldFetch,
    envConfig
  )

  const isLoadingPermissions = hasAccount && (!shouldFetch || isLoading)

  return (
    <AppContext.Provider
      value={{
        rolData: {
          ...data,
          role: Array.isArray(data?.role)
            ? data.role
            : data?.role
            ? [data.role]
            : []
        },
        isLoadingPermissions,
        permissionsError: isError,
        envConfig,
        accounts
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
